import { render, staticRenderFns } from "./EXProposalInsureds.vue?vue&type=template&id=2e39366d"
import script from "./EXProposalInsureds.vue?vue&type=script&lang=js"
export * from "./EXProposalInsureds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports